import Vue from 'vue';
import config from 'libs/config.js';
import VueMouseTrap from 'vue-mousetrap';
import PortalVue from 'portal-vue';
import Api from '@/plugins/api.js';
import Logger from '@/plugins/logger.js';
import Sanitizer from '@/plugins/sanitizer.js';
import GlobalComponents from '@/plugins/globalcomponents.js';
import Security from '@/plugins/security.js';
import Module from '@/plugins/modules.js';
import Utils, { geturi } from 'libs/utils';


Vue.use(VueMouseTrap);
Vue.use(PortalVue);
Vue.use(GlobalComponents);
Vue.use(Api, { baseuri: config.baseuri });
Vue.use(Logger);
Vue.use(Security);
Vue.use(Sanitizer);
Vue.use(Module);

window.getObjectDetailUrl = (autoid) => {
  return geturi(`/frontoffice/object/${autoid}`);
  // if (Utils.getCookie('backintime') === 'true') {
  //   return geturi(`/ObjectDetail.aspx?ObjectID=${autoid}`);
  // } else {
  //   return geturi(`/frontoffice/object/${autoid}`);
  // }
};